import React from 'react';
var RenderAction; // Map of (invalidated, loading, error) to render action

(function (RenderAction) {
  RenderAction[RenderAction["RenderLoading"] = 0] = "RenderLoading";
  RenderAction[RenderAction["RenderContent"] = 1] = "RenderContent";
  RenderAction[RenderAction["RenderError"] = 2] = "RenderError";
})(RenderAction || (RenderAction = {}));

const RenderMap = {
  0: {
    0: {
      0: RenderAction.RenderContent,
      1: RenderAction.RenderError
    },
    1: {
      0: RenderAction.RenderContent,
      1: RenderAction.RenderLoading
    }
  },
  1: {
    0: {
      0: RenderAction.RenderLoading,
      1: RenderAction.RenderError
    },
    1: {
      0: RenderAction.RenderLoading,
      1: RenderAction.RenderLoading
    }
  }
};
/**
 * Handles the "page state" which is a 3-tuple (invalidated, loading, error) according to
 * what I think is the correct UI/UX.
 */

const PageContent = ({
  renderContent,
  renderLoading,
  renderError,
  error,
  loading,
  invalidated
}) => {
  const idxInvalidated = invalidated ? 1 : 0;
  const idxLoading = loading ? 1 : 0;
  const idxError = error ? 1 : 0;
  const renderAction = RenderMap[idxInvalidated] && RenderMap[idxInvalidated][idxLoading] && RenderMap[idxInvalidated][idxLoading][idxError];

  switch (renderAction) {
    case RenderAction.RenderContent:
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderContent());

    case RenderAction.RenderLoading:
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderLoading());

    case RenderAction.RenderError:
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderError());
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, renderError());
};

export default PageContent;